import styled from "styled-components";
import { LinearProgress as LinearProgressUI } from "@material-ui/core";
import { LinearProgressProps } from "@material-ui/core/LinearProgress";
import React from "react";

interface IProps extends LinearProgressProps {
  pinToTop: boolean;
}

export const STLinearProgress = styled(({ pinToTop, ...rest }: IProps) => (
  <LinearProgressUI {...rest} />
)).attrs({
  classes: {
    barColorPrimary: "barColorPrimary",
  },
})`
  && {
    position: absolute;
    width: 100%;
    z-index: 1;
    top: ${(props: IProps) => (props.pinToTop ? "0" : "64")}px;

    .barColorPrimary {
      background-color: #2196f3;
    }
  }
`;
